import { useParams } from '@tanstack/react-router'

export function useCourseId() {
	const { courseId } = useParams({ strict: false })
	if (!courseId) {
		throw new Error('Course ID is required')
	}

	return courseId
}
